import {Injectable} from '@angular/core';
import {FormDefinitionFieldModel} from "../../../api/entity/formDefinitionField.model";
import {AbstractDataServiceDtoSummaryAdapter} from "../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter";
import {FormDefinitionFieldSummaryConverter} from "../../../api/entity/converter/formDefinitionFieldSummary.converter";
import {FormDefinitionFieldSummaryModel} from "../../../api/entity/formDefinitionFieldSummary.model";
import {FormDefinitionFieldDataService} from "./formDefinitionFieldData.service";

@Injectable()
export class FormDefinitionFieldSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<FormDefinitionFieldSummaryModel, FormDefinitionFieldSummaryConverter, FormDefinitionFieldModel> {
    constructor(dataService: FormDefinitionFieldDataService, converter: FormDefinitionFieldSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): FormDefinitionFieldModel {
        return new FormDefinitionFieldModel();
    }


}
